var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:{'fill-height': !!_vm.center},attrs:{"fluid":_vm.fluid}},[(!!_vm.center)?[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"auto"}},[_vm._t("default")],2)],1)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }